import { useCallback, useState } from 'react';
import type { StudioConfig } from './types';

export function useConfigHistory(initial: StudioConfig) {
  const [present, setPresent] = useState(initial);
  const [past, setPast] = useState<StudioConfig[]>([]);
  const [future, setFuture] = useState<StudioConfig[]>([]);

  const update = useCallback((patch: Partial<StudioConfig> | ((current: StudioConfig) => StudioConfig)) => {
    setPresent((current) => {
      const next = typeof patch === 'function' ? patch(current) : { ...current, ...patch };
      if (JSON.stringify(next) === JSON.stringify(current)) return current;
      setPast((items) => [...items.slice(-59), current]);
      setFuture([]);
      return next;
    });
  }, []);

  const undo = useCallback(() => {
    setPast((items) => {
      if (!items.length) return items;
      const previous = items[items.length - 1];
      setPresent((current) => {
        setFuture((nextItems) => [current, ...nextItems].slice(0, 60));
        return previous;
      });
      return items.slice(0, -1);
    });
  }, []);

  const redo = useCallback(() => {
    setFuture((items) => {
      if (!items.length) return items;
      const next = items[0];
      setPresent((current) => {
        setPast((previousItems) => [...previousItems.slice(-59), current]);
        return next;
      });
      return items.slice(1);
    });
  }, []);

  return { config: present, update, undo, redo, canUndo: past.length > 0, canRedo: future.length > 0 };
}
